import type { DeliveredListResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { DiscoveredLpsGateway } from './discovered-lps.gateway';

/**
 * Real implementation over the shared api client. This is the single place that
 * knows the delivered-lists endpoint. `api.get` unwraps the
 * `{ success, data }` envelope, so we get the `DeliveredListResponse[]` directly.
 */
export const httpDiscoveredLpsGateway: DiscoveredLpsGateway = {
  fetchLists: () => api.get<DeliveredListResponse[]>('/lists/delivered'),
};
